import { OptionProps } from 'react-apollo';
import { Props } from './index';
import {
  ChartDataQuery,
  ChartDataQueryVariables,
  ChartDataQuery_lab_idea_chartData as ChartData,
} from './__generated__/ChartDataQuery';

export { ChartDataQuery, ChartDataQueryVariables } from './__generated__/ChartDataQuery';

export interface Data {
  chartData?: ChartData;
}

export const responseToProps = ({
  data,
}: OptionProps<Props, ChartDataQuery, ChartDataQueryVariables>): Data => {
  if (!data || !data.lab || !data.lab.idea || !data.lab.idea.chartData) {
    return {};
  }

  return { chartData: data.lab.idea.chartData || undefined };
};
